import { logger } from "#app/monitoring/Logger";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { useUpdateExcludedProcessSteps } from "#modules/similarPart/infra/clustering/useUpdateExcludedProcessSteps";
import { ProcessStep } from "shared";

export const useExcludedProcessStepsActions = ({
  sourceQuoteRequestLine,
}: {
  sourceQuoteRequestLine: QuoteRequestLineDto;
}): [
  ProcessStep[],
  {
    excludeProcessStep: (processStep: ProcessStep) => void;
    includeProcessStep: (processStep: ProcessStep) => void;
  },
] => {
  const { updateExcludedProcessSteps } = useUpdateExcludedProcessSteps({
    sourceQuoteRequestLineId: sourceQuoteRequestLine.id,
    clusterId: sourceQuoteRequestLine.cluster?.id,
  });

  const excludedProcessSteps = sourceQuoteRequestLine.cluster?.excludedProcessSteps ?? [];

  const save = (newArray: ProcessStep[]) => {
    if (!sourceQuoteRequestLine.cluster) {
      logger.error("No cluster found");

      return;
    }

    updateExcludedProcessSteps({
      clusterId: sourceQuoteRequestLine.cluster.id,
      excludedProcessSteps: newArray,
    });
  };

  const excludeProcessStep = (processStep: ProcessStep) => {
    const newExcludedProcessStepsArray = [processStep, ...excludedProcessSteps];

    save(newExcludedProcessStepsArray);
  };

  const includeProcessStep = (processStep: ProcessStep) => {
    const newExcludedProcessStepsArray = excludedProcessSteps.filter(
      (excludedProcessStep) => excludedProcessStep.id !== processStep.id,
    );

    save(newExcludedProcessStepsArray);
  };

  return [excludedProcessSteps, { excludeProcessStep, includeProcessStep }];
};
